import React, { useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useState } from "react";
import axios from "axios";
import config from "../config";
import Faq from "./Faq";
import homeslider from "../image/membership_bg.jpg";
import member from "../image/membership.jpg";
import fitman from "../image/fitman.png";
import testimonial from "../image/testimonial.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import mumbai from "../image/mumbai.png";
import delhi from "../image/delhi.png";
import lucknow from "../image/lucknow.png";
import varanasi from "../image/varanasi.png";
import kanpur from "../image/kanpur.png";
import patna from "../image/patna.png";
import pune from "../image/pune.png";
import noida from "../image/noida.png";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function GymMembership() {
  const brand = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1921 },
      items: 8,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 1920, min: 1025 },
      items: 5,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 769 },
      items: 4,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 2,
      slidesToSlide: 1,
    },
  };

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1921 },
      items: 1,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 1920, min: 1025 },
      items: 2,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 769 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    city: "",
    intrested_area: "",
    message: "",
  });

  const [error, setError] = useState({
    nameError: "",
    phoneError: "",
    cityError: "",
    areaError: "",
    messageError: "",
  });

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(
        `${config.apiUrl}/member-enquiry`,
        {
          name: formData.name,
          phone: formData.phone,
          city: formData.city,
          interested_area: formData.intrested_area,
          message: formData.message,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setTimeout(() => {
        const modalElement = document.getElementById("memberEnquiry");
        const modal = window.bootstrap.Modal.getInstance(modalElement);
        modal.hide();
      }, 1500);
      resetFormData();
      reserError();
    } catch (error) {
      if (error.response.status === 422) {
        setError({
          nameError: error.response.data.errors.name
            ? error.response.data.errors.name[0]
            : "",
          phoneError: error.response.data.errors.phone
            ? error.response.data.errors.phone[0]
            : "",
          cityError: error.response.data.errors.city
            ? error.response.data.errors.city[0]
            : "",
          areaError: error.response.data.errors.interested_area
            ? error.response.data.errors.interested_area[0]
            : "",
          messageError: error.response.data.errors.message
            ? error.response.data.errors.message[0]
            : "",
        });
      }
    }
  };

  const resetFormData = () => {
    setFormData({
      name: "",
      phone: "",
      city: "",
      intrested_area: "",
      message: "",
    });
  };

  const reserError = () => {
    setError({
      nameError: "",
      phoneError: "",
      cityError: "",
      areaError: "",
      messageError: "",
    });
  };

  useEffect(() => {
    const modalElement = document.getElementById("memberEnquiry");
    setTimeout(() => {
      const modal = new window.bootstrap.Modal(modalElement);
      modal.show();
    }, [1500]);

    modalElement.addEventListener("hidden.bs.modal", () => {
      document.body.style.overflowY = "";
      const backdropElement = document.querySelector(".modal-backdrop");
      if (backdropElement) {
        backdropElement.remove();
      }
    });
  }, []);

  const [city, setCity] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}/city-list`);
        setCity(response.data.city_list);
      } catch (error) {}
    };
    fetchData();
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Gym Discount Coupons & Membership Offers | MeraGym</title>
          <meta
            name="description"
            content="Get exclusive gym discount coupons and save big on gym memberships across India. Enjoy fitness at affordable rates with limited-time offers from MeraGym partner gyms."
          />
          <link rel="canonical" href="https://meragym.com/gym-membership-discounts-coupon" />
          <meta property="og:title" content="Gym Discount Coupons & Membership Offers | MeraGym" />
          <meta property="og:description" content="Exclusive gym coupons and membership discounts from partner gyms across India. Save on fitness today." />
          <meta property="og:url" content="https://meragym.com/gym-membership-discounts-coupon" />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Gym Discount Coupons & Membership Offers | MeraGym" />
          <meta name="twitter:description" content="Exclusive gym coupons and membership discounts from partner gyms across India." />
        </Helmet>
      </HelmetProvider>
      <ToastContainer />
      <section className="membership_section">
        <div className="slider">
          <img src={homeslider} className="img-fluid" alt="membership" />
        </div>
      </section>
      <section className="clients-section">
        <div className="container">
          <div className="row brand-style">
            <div className="col-lg-3">
              <h5 className="title text-lg-start text-center">
                Our Trusted Partners:
              </h5>
            </div>
            <div className="col-lg-9">
              <div className="brand-swiper">
                <Carousel
                  responsive={brand}
                  swipeable={false}
                  draggable={false}
                  infinite={true}
                  showDots={false}
                  autoPlay={true}
                  autoPlaySpeed={4000}
                  removeArrowOnDeviceType={["mobile", "tablet", "desktop"]}
                >
                  <div className="brand-item">
                    <p>Hipe The Gym - Mahendergarg</p>
                  </div>
                  <div className="brand-item">
                    <p>FlexFlow Fitness - Kotdwara</p>
                  </div>
                  <div className="brand-item">
                    <p>Urban Kinetic Gym - Shillong</p>
                  </div>
                  <div className="brand-item">
                    <p>Body Maker - Khandwa</p>
                  </div>
                  <div className="brand-item">
                    <p>BOB'S GYM - Varanasi</p>
                  </div>
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="member_join_section">
        <div className="container">
          <div className="join">
            <div className="row align-items-center gy-3">
              <div className="col-12 col-lg-6">
                <img src={member} className="img-fluid" alt="membership" />
              </div>
              <div className="col-12 col-lg-6">
                <div className="content">
                  <h1 className="title">
                    Get Our Membership and Start Your Fitness Journey Today
                  </h1>
                  <p className="desc">
                    Mera Gym is more than just a fitness center – it's a
                    community of individuals dedicated to transforming their
                    lives through health and wellness.
                  </p>
                  <button
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#memberEnquiry"
                  >
                    Get Membership
                    <i className="bi bi-caret-right-fill"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cities_section">
        <div className="container">
          <h2 className="offHead text-start avail-text head-row">
            Gym discounts coupon available In
          </h2>
          <div className="city_list">
            <div className="city">
              <img src={mumbai} alt="mumbai" className="img-fluid" />
              <p>Mumbai</p>
            </div>
            <div className="city">
              <img src={delhi} alt="delhi" className="img-fluid" />
              <p>Delhi</p>
            </div>
            <div className="city">
              <img src={varanasi} alt="Varanasi" className="img-fluid" />
              <p>Varanasi</p>
            </div>
            <div className="city">
              <img src={pune} alt="Pune" className="img-fluid" />
              <p>Pune</p>
            </div>
            <div className="city">
              <img src={lucknow} alt="Lucknow" className="img-fluid" />
              <p>Lucknow</p>
            </div>
            <div className="city">
              <img src={kanpur} alt="Kanpur" className="img-fluid" />
              <p>Kanpur</p>
            </div>
            <div className="city">
              <img src={noida} alt="Noida" className="img-fluid" />
              <p>Noida</p>
            </div>
            <div className="city">
              <img src={patna} alt="Patna" className="img-fluid" />
              <p>Patna</p>
            </div>
          </div>
        </div>
      </section>
      <section className="join-section">
        <div className="container">
          <div className="row gy-md-5">
            <div className="col-12 col-lg-6">
              <div className="intro">
                <h2>How to get Gym Discount Coupons from Mera Gym</h2>
              </div>
              <ul>
                <li>Take Advantage of Seasonal Offers</li>
                <li>Utilize Referral Programs</li>
                <li>Inquire About Corporate or Group Discounts</li>
                <li> Negotiate and Ask for Hidden Deals</li>
                <li>
                  {" "}
                  Sign Up During Pre-Opening Sales or New Branch Launches
                </li>
              </ul>
            </div>
            <div className="col-12 col-lg-6">
              <div className="image-layout">
                <img src={fitman} className="img-fluid" alt="fit-man" />
                <div className="round-shape">
                  <svg
                    width="550"
                    height="747"
                    viewBox="0 0 747 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    {" "}
                    <circle
                      cx="373.5"
                      cy="373.5"
                      r="328.5"
                      stroke="url(#paint0_linear_321_1202)"
                      strokeWidth="90"
                    ></circle>{" "}
                    <defs>
                      {" "}
                      <linearGradient
                        id="paint0_linear_321_1202"
                        x1="747"
                        y1="-2.22623e-05"
                        x2="-6.6787e-05"
                        y2="747"
                        gradientUnits="userSpaceOnUse"
                      >
                        {" "}
                        <stop stopColor="#E50130" offset="0.1"></stop>{" "}
                        <stop
                          offset="1"
                          stopColor="#150C0E"
                          stopOpacity="0.2"
                        ></stop>{" "}
                      </linearGradient>{" "}
                    </defs>{" "}
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonial-section">
        <div className="container">
          <div className="intro">
            <h2>Gym Discount Coupons Testimonials</h2>
            <h4>
              Member Success Stories: Achieving Results with Tailored Programs
              and Expert Guidance
            </h4>
          </div>
          <div className="testimonial-area">
            <Carousel
              responsive={responsive}
              swipeable={true}
              draggable={true}
              infinite={true}
              showDots={true}
              autoPlay={false}
              autoPlaySpeed={3000}
              removeArrowOnDeviceType={["mobile", "tablet", "desktop"]}
            >
              <div className="testimonial-box">
                <div className="testimonial-box-content">
                  <div className="testimonial-head">
                    <div className="testimonial-left">
                      <img src={testimonial} className="img-fluid" alt="Anjali Mehra - MeraGym member" />
                    </div>
                    <div className="testimonial-right">
                      <h4>Anjali Mehra</h4>
                      <p>Mumbai</p>
                    </div>
                  </div>
                  <div className="testimonial-content">
                    <p>
                      I was looking for a gym membership, but the prices were a
                      bit steep for my budget. Thankfully, I came across this
                      amazing service that helped me get a fantastic discount.
                      Now, I enjoy working out at my favorite gym without
                      worrying about the costs. Highly recommend!
                    </p>
                  </div>
                  <div className="abs-icon">
                    <i className="fas fa-quote-right"></i>
                  </div>
                </div>
              </div>
              <div className="testimonial-box">
                <div className="testimonial-box-content">
                  <div className="testimonial-head">
                    <div className="testimonial-left">
                      <img src={testimonial} className="img-fluid" alt="Rohit Sharma - MeraGym member" />
                    </div>
                    <div className="testimonial-right">
                      <h4>Rohit Sharma</h4>
                      <p>Delhi</p>
                    </div>
                  </div>
                  <div className="testimonial-content">
                    <p>
                      As a fitness enthusiast, I wanted to join a premium gym,
                      but the fees were too high. Then I found out about the
                      discounts offered here, and it was a game-changer! I got a
                      great deal on my membership, and the process was so easy
                      and smooth. Super happy with the savings!
                    </p>
                  </div>
                  <div className="abs-icon">
                    <i className="fas fa-quote-right"></i>
                  </div>
                </div>
              </div>
              <div className="testimonial-box">
                <div className="testimonial-box-content">
                  <div className="testimonial-head">
                    <div className="testimonial-left">
                      <img src={testimonial} className="img-fluid" alt="Priya Nair - MeraGym member" />
                    </div>
                    <div className="testimonial-right">
                      <h4>Priya Nair</h4>
                      <p>Bengaluru</p>
                    </div>
                  </div>
                  <div className="testimonial-content">
                    <p>
                      I had been planning to start my fitness journey, but most
                      gyms were way beyond my budget. Thanks to this service, I
                      managed to get a significant discount, and now I’m a
                      regular at my local gym. Couldn’t have asked for a better
                      deal!
                    </p>
                  </div>
                  <div className="abs-icon">
                    <i className="fas fa-quote-right"></i>
                  </div>
                </div>
              </div>
              <div className="testimonial-box">
                <div className="testimonial-box-content">
                  <div className="testimonial-head">
                    <div className="testimonial-left">
                      <img src={testimonial} className="img-fluid" alt="Amit Singh - MeraGym member" />
                    </div>
                    <div className="testimonial-right">
                      <h4>Amit Singh</h4>
                      <p>Lucknow</p>
                    </div>
                  </div>
                  <div className="testimonial-content">
                    <p>
                      Joining a good gym was always a dream, but the high
                      membership fees kept holding me back. That’s when I
                      stumbled upon this service and secured a discount that
                      made the membership affordable. Really grateful for the
                      savings!
                    </p>
                  </div>
                  <div className="abs-icon">
                    <i className="fas fa-quote-right"></i>
                  </div>
                </div>
              </div>
              <div className="testimonial-box">
                <div className="testimonial-box-content">
                  <div className="testimonial-head">
                    <div className="testimonial-left">
                      <img src={testimonial} className="img-fluid" alt="Sneha Patel - MeraGym member" />
                    </div>
                    <div className="testimonial-right">
                      <h4>Sneha Patel</h4>
                      <p>Ahmedabad</p>
                    </div>
                  </div>
                  <div className="testimonial-content">
                    <p>
                      I wanted to get back into shape, but the gym memberships I
                      looked at were too pricey. Luckily, I found this platform
                      that offered me a discount on my preferred gym. I’m now a
                      member and thrilled with the value I received!
                    </p>
                  </div>
                  <div className="abs-icon">
                    <i className="fas fa-quote-right"></i>
                  </div>
                </div>
              </div>
            </Carousel>
          </div>
        </div>
      </section>

      {/**Membership Enquiry*/}
      <div
        className="modal fade"
        id="memberEnquiry"
        tabIndex="-1"
        aria-labelledby="memberEnquiry"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content member-modal">
            <div className="header">
              <h6 className="product-title">
                Fill this form to get gym discount coupons
              </h6>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-12 col-lg-6 mb-3">
                    <label className="form-label" htmlFor="name">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      id="name"
                      value={formData.name}
                      onChange={handleFormChange}
                    />
                    {error.nameError ? (
                      <small className="text-danger"> {error.nameError} </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                    <label className="form-label" htmlFor="phone">
                      Phone Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="phone"
                      id="phone"
                      value={formData.phone}
                      onChange={handleFormChange}
                    />
                    {error.phoneError ? (
                      <small className="text-danger">
                        {" "}
                        {error.phoneError}{" "}
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                    <label className="form-label" htmlFor="city">
                      City
                    </label>
                    <select
                      className="form-select"
                      name="city"
                      id="city"
                      onChange={handleFormChange}
                    >
                      <option value="">Select City</option>
                      {city.map((data, index) => {
                        return (
                          <option value={data.city} key={index}>
                            {data.city}
                          </option>
                        );
                      })}
                    </select>
                    {error.cityError ? (
                      <small className="text-danger"> {error.cityError} </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                    <label className="form-label" htmlFor="intrested_area">
                      Area
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="intrested_area"
                      id="intrested_area"
                      value={formData.intrested_area}
                      onChange={handleFormChange}
                    />
                    {error.areaError ? (
                      <small className="text-danger"> {error.areaError} </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-12 mb-3">
                    <label className="form-label" htmlFor="message">
                      Your Message
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      name="message"
                      id="message"
                      value={formData.message}
                      onChange={handleFormChange}
                    />
                  </div>
                  <div className="col-12 text-end">
                    <button type="submit" className="submit">
                      Submit Now
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* End Membership enquiry */}
      <Faq page="gym_membership" />
    </>
  );
}
